import session from 'lib/session';
import { get, put } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';

export const actions = {
  getLanguages: get`/languages/${session.getMerchant}/available`((res) => ({
    languages: res.map((lang) => ({
      locale: lang.locale,
      id: lang.id,
      name: lang.name,
    })),
  })),
  getMarkets:
    get`/merchants/${session.getMerchant}/markets/${session.getMerchant}`(
      (res) => ({
        markets: res,
      })
    ),
  getAvailableMarkets:
    get`/merchants/${session.getMerchant}/markets/${session.getMerchant}/available-markets`(
      (res) => ({
        markets: res,
      })
    ),
  getAvailableCurrencies: get`/currencies/${session.getMerchant}/available`(
    (res) => ({
      currencies: res,
    })
  ),
  put: put`settings/index-configuration/popularity`(),
};

export const reducer = createReducer(actions);
